<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="9" md="5">
                        <v-form v-model="formValid">
                            <v-text-field
                                id="styled-input"
                                v-model="inputedText"
                                color="teal darken-4"
                                class="styled-input"
                                clearable
                                :rules="[validationRules.required]"
                                counter
                                maxlength="40"
                                @keydown.enter.prevent="doSearchAddress"
                            >
                                <template
                                    v-slot:label
                                >{{$t('Введите адрес лицевого счёта (пример: байзакова 221 1)')}}</template>
                            </v-text-field>
                        </v-form>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center">
                    <v-btn
                        rounded
                        color="teal darken-4"
                        dark
                        :disabled="!formValid"
                        @click="doSearchAddress"
                    >{{$t('Поиск')}}</v-btn>
                </v-row>
                <v-row align="center" justify="center">
                    <div class="text-center">
                        <h3>{{ $t(message) }}</h3>
                    </div>
                </v-row>
            </v-col>
        </v-row>
        <v-row align="center" justify="center">
            <div v-if="accountAddressesLoading" class="text-center">
                <v-progress-circular :size="100" indeterminate color="teal"></v-progress-circular>
            </div>
        </v-row>
        <v-row align="center" justify="center">
            <div v-if="showResults" class="text-center title">{{$t('Выберите адрес')}}</div>
        </v-row>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="4" md="4">
                <div class="text-center">
                    <v-data-table
                        v-if="showResults"
                        class="elevation-12"
                        :headers="headers"
                        :items="accountAddresses01"
                        :loading="loading"
                        item-key="account_f_id"
                        hide-default-footer
                        hide-default-header
                        no-data-text
                    >
                        <template v-slot:body="{ items }">
                            <tbody>
                                <tr
                                    v-for="item in items"
                                    :key="item.account_f_id"
                                    @click="selectAddress(item)"
                                >
                                    <td>{{ item.account_address }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-data-table>
                </div>
            </v-col>
            <v-col cols="12" sm="4" md="4">
                <div class="text-center">
                    <v-data-table
                        v-if="showResults"
                        :headers="headers"
                        :items="accountAddresses02"
                        :loading="loading"
                        item-key="account_f_id"
                        hide-default-footer
                        hide-default-header
                        no-data-text
                        class="elevation-12"
                    >
                        <template v-slot:body="{ items }">
                            <tbody>
                                <tr
                                    v-for="item in items"
                                    :key="item.account_f_id"
                                    @click="selectAddress(item)"
                                >
                                    <td>{{ item.account_address }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-data-table>
                </div>
            </v-col>
            <v-col cols="12" sm="4" md="4">
                <div class="text-center">
                    <v-data-table
                        v-if="showResults"
                        :headers="headers"
                        :items="accountAddresses03"
                        :loading="loading"
                        item-key="account_f_id"
                        hide-default-footer
                        hide-default-header
                        no-data-text
                        class="elevation-12"
                    >
                        <template v-slot:body="{ items }">
                            <tbody>
                                <tr
                                    v-for="item in items"
                                    :key="item.account_f_id"
                                    @click="selectAddress(item)"
                                >
                                    <td>{{ item.account_address }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-data-table>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    components: {},
    data() {
        return {
            formValid: true,
            loading: false,
            inputedText: '',
            headers: [{ text: 'Адрес', value: 'account_address' }],
            message: '',
            validationRules: {
                required: value => (!value ? this.$t('Не указан адрес') : true)
            }
        };
    },
    computed: {
        ...mapState('print', ['accountAddresses', 'accountAddressesLoading']),
        ...mapGetters('print', ['accountAddresses01', 'accountAddresses02', 'accountAddresses03']),

        showResults() {
            return this.inputedText && this.accountAddresses && this.accountAddresses.length > 0;
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.init();
        });
    },
    methods: {
        ...mapActions('print', ['init', 'searchAddresses', 'selectAccount']),
        async doSearchAddress() {
            if (!this.formValid) return;
            let recaptchaToken = await this.recaptcha('/searchAddress');
            this.searchAddresses({ addressText: this.inputedText, recaptchaToken: recaptchaToken });
        },
        selectAddress(value) {
            this.selectAccount(value);
            this.$router.push('/print');
        },
        async recaptcha(action) {
            let token = await this.$recaptcha(action);
            return token;
        }
    }
};
</script>